import React, { useState, FC } from "react";
import { PageLogo } from "../logo/astrid&gaston";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { useFormik } from "formik";
import { Link } from "gatsby";
import * as Yup from "yup";
//styles
import "./index.scss";

const validationSchema = Yup.object({
  name: Yup.string().required("El nombre es obligatorio"),
  lastname: Yup.string().required("El apellido es obligatorio"),
  phone: Yup.string().required("El celular es obligatorio"),
  email: Yup.string().email("Correo inválido").required("El correo es obligatorio"),
  verification: Yup.boolean().oneOf([true], "Debes aceptar las políticas de privacidad")
});

export const Footer: FC<FooterProps> = ({ content }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [completed, setCompleted] = useState<boolean>(false);
  
  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      phone: "",
      lastname: "",
      utm_medium: "form",
      utm_campaign: "subscription_form",
      utm_source: "website",
      form: "subscription",
      verification: false,
    },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      fetch(`${process.env.GATSBY_WORDPRESS_URL}/wp-json/whiz-api/v1/lead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
        redirect: "follow",
      })
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error))
        .finally(() => {
          setCompleted(true);
          setSubmitting(false);
        });
    },
  });

  return (
    <div>
      <footer id="page-footer">
        <AnchorLink
          title="Volver al principio de la pagina"
          className="button-go-up"
          to="/#page-wrapper"
        >
          <span className="icon-element"></span>
        </AnchorLink>

        <div className="container-fluid">
          <div className="top">
            <PageLogo color="white" />
            <ul className="icon-container">
              {content.socialMediaLinks.map((element, index) => (
                <li className="element" key={index}>
                  <img
                    className="element__image"
                    src={element.image.node.publicUrl}
                    alt={element.image.node.altText}
                    title={element.image.node.title}
                  />
                  <a
                    className="element__redirection redirection-button"
                    rel="noopener noreferrer"
                    href={element.link}
                    target="_blank"
                  ></a>
                </li>
              ))}
            </ul>
          </div>

          <div className="middle-section">
            <div className="in-order-elements">
              {completed ? (
                <div className="links-section-bigger">
                  <p>¡Hola! Gracias por suscribirte.</p>
                  <span>
                    De ahora en adelante recibirás la información, noticias y
                    novedades de la marca.
                  </span>
                </div>
              ) : (
                <div className="links-section-bigger">
                  <form onSubmit={formik.handleSubmit} className="formulario">
                      <div className="form-group">
                        <label>
                          <input
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            className={`form-control ${formik.touched.name && formik.errors.name ? "error" : ""}`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                          />
                        </label>
                      </div>
                      <div className="form-group">
                        <label>
                          <input
                            type="text"
                            name="lastname"
                            placeholder="Apellido"
                            className={`form-control ${formik.touched.lastname && formik.errors.lastname ? "error" : ""}`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lastname}
                          />
                        </label>
                      </div>
                      <div className="form-group">
                        <label>
                          <input
                            type="tel"
                            name="phone"
                            placeholder="Celular"
                            className={`form-control ${formik.touched.phone && formik.errors.phone ? "error" : ""}`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.phone}
                          />
                        </label>
                      </div>
                      <div className="form-group bigger">
                        <label>
                          <input
                            type="email"
                            name="email"
                            placeholder="Correo"
                            className={`form-control ${formik.touched.email && formik.errors.email ? "error" : ""}`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                          />
                        </label>
                      </div>
                      <div className="form-group bigger form-validation">
                        <label className={`form-label custom-checkbox flex ${formik.touched.verification && formik.errors.verification ? "error" : ""}`}>
                          <input
                            type="checkbox"
                            name="verification"
                            className={"form-control"}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            checked={formik.values.verification}
                          />
                          <span className="checkmark"></span>
                          <span>
                            He leído y acepto las{" "}
                            <Link
                              title="políticas de privacidad"
                              to="/politica-de-privacidad"
                              className="non-styled"
                            >
                              políticas de privacidad
                            </Link>{" "}
                            de datos de esta web.
                          </span>
                        </label>
                      </div>
                      <button
                        type="submit"
                        className="button style-primary-footer"
                        disabled={formik.isSubmitting}
                      >
                        <span>Suscríbete</span>
                      </button>
                    </form>
                </div>
              )}

              <div className="links-section">
                <div className="content">
                  <p className="title">{content.firstSectionTitle}</p>
                  <ul>
                    {content.firstSectionLinks.map((element, index) => (
                      <li key={index}>
                        {element.linkType[0] == "seccion" ? (
                          <AnchorLink
                            className="nav-link"
                            to={element.linkRedirection}
                          >
                            {element.linkText}
                          </AnchorLink>
                        ) : (
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href={element.linkRedirection}
                            target="_blank"
                          >
                            {element.linkText}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="links-section">
                <div className="content">
                  <p className="title">{content.secondSectionTitle}</p>
                  <ul>
                    {content.secondSectionLinks.map((element, index) => (
                      <li key={index}>
                        {element.linkType[0] == "interna" ? (
                          <Link
                            className="nav-link"
                            to={element.linkRedirection}
                          >
                            {element.linkText}
                          </Link>
                        ) : (
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href={element.linkRedirection}
                            target="_blank"
                          >
                            {element.linkText}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="links-section libro-reclamaciones">
                <div className="icon-container column">
                  <div className="element-container">
                    <span className="icon realis-chateaux"></span>
                  </div>
                  <a
                    title="Redirección a: Libro de reclamaciones Acurios restaurantes"
                    className="title"
                    href="https://reclamaciones.acuriorestaurantes.net/libro_reclamaciones/(S(iqus2pr5xifcxvdgebgkbxad))/libro_reclamaciones.aspx"
                    target="__blank"
                  >
                    <div className="element-container">
                      <span className="icon libro-reclamaciones"></span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bottom">
            <span className="bottom__info">
              © {new Date().getFullYear()} Todos los derechos reservados a
              “Acurio Restaurantes”
            </span>
            <span className="bottom__info">
              RUC: 20509076945 - CINCO MILLAS SAC
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};
